import { useContext } from "react";
import { API } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

import AlertForm from "components/alerts/AlertForm";
import { createAlert, createAlertDevice } from "graphql/mutations";
import { LayoutContext } from "layout/context/LayoutContext";

const AlertCreateForm = ({ onSuccess }) => {
  const { me } = useContext(LayoutContext);
  const navigate = useNavigate();
  const alert = {
    name: "",
    description: "",
    severity: "",
    severityColor: "",
    devices: [],
    smsNotifications: [],
    wspNotifications: [],
    emailNotifications: [],
    conditions: [],
    companyID: me.companyID ?? "",
    startSchedule: "",
    endSchedule: "",
    days: [],
    execInterval: "hour",
    execTime: "",
    hourInterval: null,
    executeOnHolidays: false,
  };

  async function onSubmit(values) {
    try {
      const {
        name,
        description,
        severity,
        severityColor,
        devices,
        smsNotifications,
        wspNotifications,
        emailNotifications,
        conditions,
        companyID,
        startSchedule,
        endSchedule,
        days,
        execInterval,
        execTime,
        hourInterval,
        executeOnHolidays,
      } = values;

      const alert = (
        await API.graphql({
          query: createAlert.replaceAll("__typename", ""),
          variables: {
            input: {
              name,
              description,
              severity,
              severityColor,
              smsNotifications,
              wspNotifications,
              emailNotifications,
              conditions: JSON.stringify(conditions),
              companyID,
              startSchedule,
              endSchedule,
              days,
              execInterval,
              execTime,
              hourInterval,
              executeOnHolidays,
              enabled: true,
            },
          },
        })
      )?.data?.createAlert;

      const promises = [];

      promises.push(
        ...devices.reduce((promises, device) => {
          promises.push(
            API.graphql({
              query: createAlertDevice.replaceAll("__typename", ""),
              variables: {
                input: {
                  alertId: alert.id,
                  deviceId: device.id,
                },
              },
            })
          );
          return promises;
        }, [])
      );

      await Promise.all(promises);

      toast.success(strings.successAdded);
      if (onSuccess) onSuccess();
      else navigate("/alerts");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  return (
    <div>
      <AlertForm onSubmit={onSubmit} initialValues={alert} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Agregar Alerta",
    successAdded: "Alerta agregada con éxito",
    responses: {},
  },
});

export default AlertCreateForm;
